import { Box, BoxProps } from '@chakra-ui/react';
import React, { SVGAttributes } from 'react';

/**
 * SVG Text Icon
 */
interface IComponent {
  children: any;
  props?: any;
}

export type SvgBoxProps = BoxProps & SVGAttributes<HTMLOrSVGElement>;

const SvgBox: React.FC<SvgBoxProps> = ({ children, ...props }) => (
  <Box as="svg" xmlns="http://www.w3.org/2000/svg" {...props}>
    {children}
  </Box>
);

const TextIcon = ({ children, ...props }: IComponent & SvgBoxProps) => (
  <SvgBox
    display="inline-block"
    fill="currentColor"
    stroke="currentColor"
    verticalAlign="middle"
    strokeWidth={0}
    width="1.55em"
    height="1.55em"
    {...props}>
    {children}
  </SvgBox>
);

export default TextIcon;
